import { useStore } from 'effector-react'

import {
  $totalCountOfPartners,
  getPartners,
  partnersListMounted,
  $partners,
} from './model'
import { PartnersRequest } from './types'

export const useTradersList = () => {
  const partners = useStore($partners)
  const loading = useStore(getPartners.pending)
  const totalCountOfPartners = useStore($totalCountOfPartners)

  const onChangePartnersList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
  }: PartnersRequest) => {
    partnersListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
    })
  }

  return {
    partners,
    totalCountOfPartners,
    loading,
    onChangePartnersList,
  }
}
